let gpuInfo: { renderer: string; vendor: string } | undefined

export function getGpuInfo() {
  if (!gpuInfo) {
    gpuInfo = _getGpuInfo()
  }
  return gpuInfo
}

function _getGpuInfo() {
  let canvas: HTMLCanvasElement | undefined = document.createElement('canvas')
  let gl: WebGLRenderingContext | undefined = (canvas.getContext('webgl') ||
    canvas.getContext('experimental-webgl')) as WebGLRenderingContext
  if (!gl) {
    return {
      renderer: 'unknown(WebGLRenderingContext not existed)',
      vendor: 'unknown(WebGLRenderingContext not existed)'
    }
  }
  const info = gl.getExtension('WEBGL_debug_renderer_info')
  if (!info) {
    return {
      renderer: 'unknown(info not existed)',
      vendor: 'unknown(info not existed)'
    }
  }
  const renderer = gl.getParameter(info.UNMASKED_RENDERER_WEBGL)
  const vendor = gl.getParameter(info.UNMASKED_VENDOR_WEBGL)
  // canvas 与 parentNode 解绑
  if (canvas && canvas.parentNode) {
    canvas.parentNode.removeChild(canvas)
  }
  canvas = undefined
  gl = undefined
  return { renderer, vendor }
}

export function extractProfileInfo(sdpFmtpLine?: string) {
  let profileLevelId = ''
  if (!sdpFmtpLine) {
    return profileLevelId
  }
  const paramArray = sdpFmtpLine.split(';')
  for (const param of paramArray) {
    const [key, value] = param.trim().split('=')
    if (key === 'profile-level-id') {
      profileLevelId = value
    }
  }
  return profileLevelId
}
